import { styled, TextField, Paper, Box } from "@mui/material";

export const StyledPaper = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
  boxShadow: "none",
  borderRadius: 0,
};

export const MessageContainer = (theme) => ({
  flex: 1,
  padding: "10px",
  overflowY: "auto",
  backgroundColor: "#f5f5f5",
  "&::-webkit-scrollbar": {
    width: "8px",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#bdbdbd",
    borderRadius: "4px",
  },
});

export const CssTextField = styled(TextField)({
  "& label.Mui-focused": {
    color: "#A0AAB4",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#B2BAC2",
  },
  "& .MuiOutlinedInput-root": {
    "&:hover fieldset": {
      borderColor: "#B2BAC2",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#bdbdbd",
    },
  },
});

export const MessageBubble = styled(Box, {
  shouldForwardProp: (prop) => prop !== "sent",
})(({ sent }) => ({
  display: "flex",
  alignItems: "flex-end",
  marginBottom: "16px",
  flexDirection: sent ? "row-reverse" : "row",
}));

export const Message = styled(Paper, {
  shouldForwardProp: (prop) => prop !== "sent" && prop !== "bubbleColor",
})(({ sent, bubbleColor, theme }) => ({
  padding: sent ? "8px 16px 10px" : "0px 16px 12px",
  maxWidth: sent ? "88%" : "70%",
  borderRadius: sent ? "14px" : "10px",
  backgroundColor: "#fff",
  color: "#000",
  marginLeft: sent ? "0" : "8px",
  marginRight: sent ? "8px" : "0",
  position: "relative",
  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
  transition: "all 0.3s ease",
  "&:hover": {
    transform: "translateY(-1px)",
    boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
  },
  "& p": {
    margin: sent ? "6px 0" : "10px 0",
    fontSize: sent ? "15px" : "14px",
    lineHeight: sent ? 1.35 : 1.4,
  },
}));

export const InputContainer = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  padding: "10px",
  borderTop: "1px solid #e0e0e0",
  backgroundColor: "#fff",
}));
